import { combineReducers } from "redux";
import { servicesReducer } from "./servicesReducer";

const allReducers = combineReducers({
  servicesReducer: servicesReducer.reducer,
});

const rootReducer = (state, action) => allReducers(state, action);
export default rootReducer;
